import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieinfoComponent } from './cookieinfo.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        CookieinfoComponent
    ],
    exports: [
        CookieinfoComponent
    ]
})
export class CookieinfoModule {

} 